import { axios } from './axios';

function setMarketingStatus({ entity, id, marketingStatusId }) {
    return axios
        .post('/mailing/v2/marketingStatus', {
            idMarketingStatus: Number(marketingStatusId),
            entity,
            entityId: Number(id),
        })
        .then(({ data }) => data);
}

/**
 * Set marketing status for one account (company). B4: POST /mailing/v2/marketingStatus
 * @param {{ id: number, marketingStatusId: number }} params
 */
export function setMarketingConsentAccount({ id, marketingStatusId }) {
    return setMarketingStatus({
        entity: 'account',
        id,
        marketingStatusId,
    });
}

/**
 * Set marketing status for one contact. B4: POST /mailing/v2/marketingStatus
 * @param {{ id: number, marketingStatusId: number }} params
 */
export function setMarketingConsentContact({ id, marketingStatusId }) {
    return setMarketingStatus({
        entity: 'contact',
        id,
        marketingStatusId,
    });
}
